import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.common.white,
    position: 'relative',
    padding: '0',
  },
}))

export default useStyles
